/*Functionality Library*/
import f11y from 'f11y';
import { Arrive } from 'arrive';

import { isJavascriptEnabled } from "./helpers/enabled";
import { isSet } from "./helpers/isset";
import { Sticky } from "./patterns/sticky-header";
import { Video } from "./patterns/video";
import { SiteSearch } from "./patterns/site-search";
import { Toast } from "./patterns/toast";
import { ContentSearch } from "./patterns/content-search";
import { InlineSearch } from "./patterns/inline-search";
import { FieldCounter } from "./patterns/field-counter";
import { DepotFinder } from "./patterns/depot-finder";
import { EnquiryLink } from "./patterns/enquiry-link";
import { initEmblaCarousels } from "./patterns/embla-carousel-init";
import { Add2Basket } from "./patterns/add-to-basket";
import { checkStickyHeight } from "./helpers/check-sticky";


isJavascriptEnabled();


/**
 * Sticky Masthead
 */
/** @type {HTMLElement[]} */
const masthead = document.querySelector("#masthead");
if(isSet(masthead)){
    new Sticky(masthead);
}


/**
 * Height checking for other sticky elements
 */
const stickyElms = document.querySelectorAll(".is-sticky");
stickyElms.forEach( function (stickyElm) {
    checkStickyHeight(stickyElm);
});


/**
 * Initialise Enquiry Buttons
 */
const enquireForm = document.querySelector(".scotagrienquiryform2024 form");
const enquireButtonElms = document.querySelectorAll(".enquire-button--js");

enquireButtonElms.forEach( function (enquireButtonElm) {
    new EnquiryLink(enquireButtonElm, enquireForm);
});

document.arrive(
    ".enquire-button--js", 
    function(newEnquireButtonElm) {
        new EnquiryLink(newEnquireButtonElm, enquireForm);
    }
);


//Handles prefilling contact form if we have been redirected from a enquiry link
function handleContactEnquire(){
    const contactForm = document.querySelector('.scotagricontactform2024 form');

    if(!isSet(contactForm)) return;

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    if(params.enquire !== "true") return;

    const getMessage = JSON.parse(localStorage.getItem("message"));

    if(!isSet(getMessage)) return;

    let prefix = '';

    switch (getMessage.type) {
        case 'stock':
            prefix = 'the stock item: ';
            break;
        case 'machinery':
            prefix = 'the machinery model: ';
            break;
        default:
            break;
    }

    const messageField = contactForm.querySelector('.message textarea');

    if(isSet(messageField)){
        const messageValue = "Hello, I would like to make an enquiry regarding "+ prefix + ' "' + getMessage.title + '"';
        messageField.value = messageValue;

        const yOffset = -100; 
        const y = contactForm.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo(
            {
                top: y, 
                behavior: 'smooth'
            }
        );
    }
}
handleContactEnquire();

/**
 * Initialise Embla Carousels
 */
initEmblaCarousels();
document.arrive(
    ".embla", 
    function() {
        initEmblaCarousels();
    }
);


/**
 * Initialise TabLists
 */
/** @type {HTMLElement[]} */
const tabLists = document.querySelectorAll(".tabs--js");
tabLists.forEach( function (tabList) {
    new f11y.components.TabList(
        tabList
    );
});


/**
 * Expandable Menu Accordions
 */
/** @type {HTMLElement[]} */
const expandableMenus = document.querySelectorAll(".has-expandable--js");

/** @type {DropdownDefault} */
const expandableMenuOpts = {
}

expandableMenus.forEach(function (expandableMenuElm) {
    new f11y.components.Accordion(
        expandableMenuElm,
        expandableMenuOpts
    );
});


/**
 * Menu Dropdowns
 */
/** @type {HTMLElement[]} */
const menuDropdowns = document.querySelectorAll(".has-popup--js");

/** @type DropdownDefault */
const menuDropdownOpts = {
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
}

menuDropdowns.forEach(function (menuDropdownElm) {
    new f11y.components.Dropdown(
        menuDropdownElm,
        menuDropdownOpts
        );
});


/**
 * Mega Menu Dropdowns
 */
/** @type {HTMLElement[]} */
const megaMenus = document.querySelectorAll(".has-mega-menu--js");

/** @type DropdownDefault */
const megaMenuOpts = {
    tabNavigation: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
}

megaMenus.forEach(function (megaMenuElm) {
    new f11y.components.Dropdown(
        megaMenuElm,
        megaMenuOpts
        );
});


/**
 * filter Accordions
 */
const filters = document.querySelectorAll(".filter--js");
filters.forEach(function (filter) {
    new f11y.components.Accordion(
        filter,
        {
            onClose: function() {
                const stickyElms = document.querySelectorAll(".is-sticky");
                
                stickyElms.forEach( function (stickyElm) {
                    checkStickyHeight(stickyElm);
                });
            },
            onOpen: function() {
                const stickyElms = document.querySelectorAll(".is-sticky");
                stickyElms.forEach( function (stickyElm) {
                    checkStickyHeight(stickyElm);
                });
            },
            showMultiple: true,
        }
    );
});


/**
 * Machinery Type Accordions
 */
const subTypes = document.querySelectorAll(".sub-types--js");
subTypes.forEach(function (accordion) {
    new f11y.components.Accordion(
        accordion,
        {
            onOpen: function(itemObj){
                const subTypeContainer = itemObj.item.closest('article');
                subTypeContainer.classList.add('is-open');
            },
            onClose: function(itemObj){
                const subTypeContainer = itemObj.item.closest('article');
                subTypeContainer.classList.remove('is-open');
            },
            showMultiple: true,
        }
    );
});


document.arrive(
    ".sub-types--js", 
    function(newElm) {
        new f11y.components.Accordion(
            newElm,
            {
                onOpen: function(itemObj){
                    const subTypeContainer = itemObj.item.closest('article');
                    subTypeContainer.classList.add('is-open');
                },
                onClose: function(itemObj){
                    const subTypeContainer = itemObj.item.closest('article');
                    subTypeContainer.classList.remove('is-open');
                },
                showMultiple: true,
            }
        );
    }
);


/**
 * Modals
 */
/** @type {HTMLElement[]} */
const modals = document.querySelectorAll(".layer--js");

let isMastheadHidden;

/** @type DropdownDefault */
const modalOpts = {
    onOpen: function(obj){
        if(obj.domNode.id === "layer--mobile-nav") return;
        const masthead = document.querySelector("#masthead");

        if(!masthead.classList.contains('hide')){
            masthead.classList.add('hide');
            isMastheadHidden = true
        }else{
            isMastheadHidden = false
        }
    },
    onClose: function(){
        if(isMastheadHidden === true){
            masthead.classList.remove('hide');
        }
    },
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
}

modals.forEach(function (modalElm) {
    new f11y.components.Layer(
        modalElm,
        modalOpts
    );
});

document.arrive(
    ".layer--js", 
    function(newElm) {
        new f11y.components.Layer(
            newElm,
            modalOpts
        );
    }
);


/**
 * Vimeo Videos
 */
/** @type {HTMLElement[]} */
const vimeoVideos = document.querySelectorAll("[data-vimeo-url]");

vimeoVideos.forEach(function (vimeoVideoElm) {
    new Video(vimeoVideoElm);
});


/**
 * Initialise Custom Select Fields
 */
const selectFields = document.querySelectorAll(".sa-field--dropdown--js select");
selectFields.forEach(function (selectElm) {
    NiceSelect.bind(
        selectElm, 
        {
            searchable: false, 
            placeholder: 'select', 
            searchtext: 'Search...', 
            selectedtext: 'Selected'
        }
    );
});

let elements = window.f11y.focusableElements;
elements.push('[role=menuitem]');
window.f11y.focusableElements = elements;


const customDropdownFields = document.querySelectorAll(".sa-field--custom-dropdown--js");
customDropdownFields.forEach(function (dropdownElm) {

    let trigger = dropdownElm.querySelector('button');
    let triggerid = trigger.id;
    let selector = '#' + triggerid + ' > span';

    new f11y.components.Dropdown(
        dropdownElm,
        {
            onAfterClose: (object, e) => {
                if(!dropdownElm.contains(e.target)) return;

                object.dropdownItems.forEach((item)=>{
                    item.classList.remove('is-selected')
                });
                
                e.currentTarget.classList.add('is-selected');
                selectionMade(e, object, dropdownElm);
            },
            updateOnSelect: true,
            closeOnSelect: true,
            updateSelector: selector
        }
    );
});

function selectionMade(e, object, dropdown) {
    let value = e.target.textContent;

    object.updateTargetNode.dataset.value = value;
    const eventDetail = {
        detail: {
          event: e,
          object: object,
          dropdown: dropdown
        }
    };
    const customEvent = new CustomEvent('optionChanged', eventDetail);

    dropdown.dispatchEvent(customEvent);
}

/**
 * Initialise custom counter fields
 */
const counterFields = document.querySelectorAll(".sa-field--counter--js");
counterFields.forEach(function (counterElm){
    new FieldCounter(counterElm)
});


/**
 * Search Functionalities
 */
const siteSearch = document.querySelector(".site-search--js");
new SiteSearch(siteSearch);

const contentSearch = document.querySelectorAll(".content-search--js");
contentSearch.forEach(function (element) {
    new ContentSearch(element);
});

const inlineSearch = document.querySelectorAll(".sa-field--inline-search--js");
inlineSearch.forEach(function (element) {
    new InlineSearch(element);
});



/**
 * Initialise Google Maps API & Depot Finder
 */
(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
    key: "AIzaSyASHgpurCiCV1hIuZiG05KQvczM-vxo_CE",
    v: "weekly",
});

const depotFinderContainer = document.querySelector('.depot-finder--js');
if(isSet(depotFinderContainer)){
    const depotFinderResultContainer = depotFinderContainer.querySelector('.results-container');

    depotFinderResultContainer.addEventListener('loaded', initMap, false);

    // Initialize and add the map
    async function initMap() {
        depotFinderResultContainer.removeEventListener('loaded', initMap, false);

        const {Map, InfoWindow} = await google.maps.importLibrary("maps");
        const {Marker} = await google.maps.importLibrary("marker");
        
        new DepotFinder(depotFinderContainer, Map, Marker, InfoWindow);
    }
}

function initiliseToasts(){
    const toastContainerElm = document.querySelector(".toast--container");
    const toastSuccessTemplate = document.querySelector('#basket-toast--success');
    const toastErrorTemplate = document.querySelector('#basket-toast--error');
    const toastOptions = {
        swipeTracking: true,
        awaitOpenTransition: true,
        awaitCloseTransition: true,
        swipeDirection: 'left'
    };
    
    window.basketSuccessAPI = new Toast(
        toastContainerElm,
        toastSuccessTemplate,
        toastOptions
    );

    window.basketErrorAPI = new Toast(
        toastContainerElm,
        toastErrorTemplate,
        toastOptions
    );
}
initiliseToasts();


const addToBasketContainer = document.querySelector(".sa-add-to-basket--js");
if(isSet(addToBasketContainer)){
    new Add2Basket(addToBasketContainer);
}



//UTM
function sa_escape(string) {
	return string
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");
}

function init_sa_UTM(){
	const utm_params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_adgroup', 'utm_term', 'utm_id'];
	const search_params = new URLSearchParams(window.location.search);
	window.dataLayer = window.dataLayer || [];

	search_params.forEach((value, key) => {
		if(utm_params.includes(key)){

			sessionStorage.setItem('sa_' + key, value );

			dataLayer.push({
				event: 'sa_' + key,
				utm_param: {
					key: key,
					value: value,
				}
			});
		}
	});

	apply_sa_UTM();
}

function apply_sa_UTM(){
	const keys = {
		utm_source : 'uTMSource',
		utm_medium : 'uTMMedium',
		utm_campaign : 'uTMCampaign',
		utm_adgroup : 'uTMAdgroup',
		utm_term : 'uTMTerm',
		utm_id : 'uTMId'
	};
	
	for(const [key, value] of Object.entries(keys)){
		const key_field_elements = Array.from(document.querySelectorAll('.' + sa_escape(value)));

		if(key_field_elements.length < 1) continue;

		const key_value = sessionStorage.getItem('sa_' + sa_escape(key));

		if(typeof key_value === 'undefined' || key_value === null || key_value === '')continue;

		key_field_elements.forEach( (key_field_element) => {
			key_field_element.value = sa_escape(key_value);
		});
	};
}

function clear_sa_UTM(){
	const keys = {
		utm_source : 'uTMSource',
		utm_medium : 'uTMMedium',
		utm_campaign : 'uTMCampaign',
		utm_adgroup : 'uTMAdgroup',
		utm_term : 'uTMTerm',
		utm_id : 'uTMId'
	};

	for(const [key, value] of Object.entries(keys)){
		const key_item = sessionStorage.getItem('sa_' + key);

		if(typeof key_item !== 'undefined' || key_item !== null || key_item !== ''){
			sessionStorage.removeItem('sa_' + key);
		}

		const key_field_elements = Array.from(document.querySelectorAll('.' + sa_escape(value)));

		if(key_field_elements.length < 1) return;

		key_field_elements.forEach( (key_field_element) => {
			key_field_element.value = '';
		});
	};
}

window.addEventListener('OneTrustGroupsUpdated', event => {
	if(event.detail.includes('C0004')){
		init_sa_UTM();
	} else{
		clear_sa_UTM();
	}
});

window.addEventListener('load' , (e) => {
	if(OnetrustActiveGroups.includes('C0004')){
		init_sa_UTM();
	} else{
		clear_sa_UTM();
	}
});